export const filterOnlyTopLeagues = (events, regions, isTopLeaguesOnly) => {
    if (!isTopLeaguesOnly) {
        return events;
    }
    const filteredEvents = events.filter(e => e.isTopLeague || regions.includes(e.regionId));
    if (filteredEvents.length) {
        return filteredEvents;
    }
    return events;
};
//# sourceMappingURL=filterOnlyTopLeagues.js.map